import React, { useState } from "react";
import { ClockIcon } from "@icons";
import { Button } from "@design-system/Button/Button";
import { TimePicker } from "@design-system/TimePicker/TimePicker";
import { formatDuration } from "@design-system/TimePicker/TimePicker.lib";
import { BooleanControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./DatePickerPlayground.module.scss";

export const TimePickerPlayground = () => {
    const [value, setValue] = useState<number | undefined>(60);
    const [isCustomTrigger, setIsCustomTrigger] = useState(false);
    const [isClearable, setIsClearable] = useState(true);
    const [isDisabled, setIsDisabled] = useState(false);

    const customTrigger = (
        <button type="button" className={styles.customTriggerChip}>
            <ClockIcon />
            {value !== undefined ? formatDuration(value) : "No estimate"}
        </button>
    );

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Features</h2>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Custom trigger"
                                checked={isCustomTrigger}
                                onChange={setIsCustomTrigger}
                            />
                            <BooleanControl
                                label="Clearable"
                                checked={isClearable}
                                onChange={setIsClearable}
                            />
                            <BooleanControl
                                label="Disabled"
                                checked={isDisabled}
                                onChange={setIsDisabled}
                            />
                        </div>
                    </section>
                    <section>
                        <h2>Actions</h2>
                        <Button
                            type="button"
                            variant="primary"
                            size="sm"
                            onClick={() => setValue(undefined)}
                        >
                            Reset value
                        </Button>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={isCustomTrigger ? "custom trigger" : "button trigger"}
                output={JSON.stringify(
                    {
                        minutes: value ?? null,
                        formatted: formatDuration(value) || null,
                    },
                    null,
                    2,
                )}
            >
                <TimePicker
                    value={value}
                    onChange={setValue}
                    isClearable={isClearable}
                    disabled={isDisabled}
                    trigger={isCustomTrigger ? customTrigger : undefined}
                />
            </ShowcasePreview>
        </SandboxLayout>
    );
};
